module.exports = "/fonts/fa-solid-900.woff2?b5cf8ae26748570d8fb95a47f46b69e1";